import Box, { type BoxProps } from '@mui/material/Box';
import { forwardRef, type ReactNode } from 'react';
import { useTitle } from 'react-use';
import { useResponsive } from '../../hooks';
import { LoadingScreen } from '../lazy-loader/loading-screen';

export interface PageProps extends BoxProps {
  children: ReactNode;
  title: string;
  isLoading?: boolean;
}

export const Page = forwardRef<HTMLDivElement, PageProps>(
  ({ children, title = '', isLoading = false, sx, ...props }, ref) => {
    useTitle(`${title} | Tyro`);
    const isDesktop = useResponsive('up', 'lg');

    return isLoading ? (
      <LoadingScreen />
    ) : (
      <Box
        ref={ref}
        className="tyro-page"
        sx={{
          ...(isDesktop && {
            px: 2,
          }),
          pb: 4,
          display: 'flex',
          flexDirection: 'column',
          flex: 1,
          ...sx,
        }}
        {...props}
      >
        {children}
      </Box>
    );
  },
);

if (process.env.NODE_ENV !== 'production') {
  Page.displayName = 'Page';
}
